import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";

const DriverStatement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { driver } = location.state || {};

  // console.log("driver data:", driver);

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">
            Statement of {driver ? driver.name : "Driver"} /{" "}
            {driver ? driver.email : "Driver"}
          </h2>
        </div>
        <div className="row">
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-info">
              <div className="inner">
                <h3>
                  $
                  {driver.totalEarning !== null &&
                  driver.totalEarning !== undefined
                    ? driver.totalEarning
                    : "0"}
                </h3>
                <p>Revenue</p>
              </div>
              <div className="icon">
                <i className="ion ion-bag" />
              </div>
            </div>
          </div>
          {/* ./col */}
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-success">
              <div className="inner">
                <h3>
                  {driver.totalRides !== null && driver.totalRides !== undefined
                    ? driver.totalRides
                    : "0"}
                </h3>
                <p>Total Rides</p>
              </div>
              <div className="icon">
                <i className="ion ion-stats-bars" />
              </div>
            </div>
          </div>
          {/* ./col */}
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-warning">
              <div className="inner">
                <h3>
                  {driver.completeRides !== null &&
                  driver.completeRides !== undefined
                    ? driver.completeRides
                    : "0"}
                </h3>
                <p>Completed Rides</p>
              </div>
              <div className="icon">
                <i className="ion ion-person-add" />
              </div>
            </div>
          </div>
          {/* ./col */}
          <div className="col-lg-3 col-6">
            {/* small box */}
            <div className="small-box bg-danger">
              <div className="inner">
                <h3>
                  {driver.cancelRides !== null &&
                  driver.cancelRides !== undefined
                    ? driver.cancelRides
                    : "0"}
                </h3>
                <p>Cancelled Rides</p>
              </div>

              <div className="icon">
                <i className="ion ion-pie-graph" />
              </div>
            </div>
          </div>
          {/* ./col */}
        </div>

        <div className="card">
          <div className="card-header flex items-center justify-between">
            <button
              type="button"
              onClick={() => navigate("/drivers")}
              className="btn btn-outline-secondary ml-2"
            >
              <FaChevronLeft className="mr-1" /> Back
            </button>
          </div>

          <div className="card-body flex flex-col gap-4">
            <div className="d-flex justify-content-between align-items-center">
              {/* Buttons aligned left */}
              <div className="d-flex gap-4">
                <button type="button" className="btn btn-outline-secondary">
                  CSV
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  Excel
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  PDF
                </button>
              </div>

              {/* Search aligned right */}

              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                style={{ width: "300px" }}
              />
            </div>

            <div className="mt-4">
              <table className="table table-bordered w-full">
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>Ride ID</th>
                    <th style={{ width: "150px" }}>Picked Up</th>
                    <th style={{ width: "150px" }}>Dropped</th>
                    <th style={{ width: "200px" }}>Date</th>
                    <th style={{ width: "100px" }}>Earned</th>
                    <th style={{ width: "100px" }}>Status</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>

          <div className="card-footer clearfix"></div>
        </div>
      </div>
    </div>
  );
};

export default DriverStatement;
